const getFortnoxReportBackStatusText = (id) => {
  switch (id) {
    case 0:
      return "OK";
    case 1:
      return "Error";
    default:
      return "";
  }
};

const getFortnoxReportBackStatusColor = (id) => {
  switch (id) {
    case 0:
      return "success";
    case 1:
      return "warning";
    default:
      return "default";
  }
};

export { getFortnoxReportBackStatusColor, getFortnoxReportBackStatusText };
